import React, { useState, useEffect } from 'react';
import avatar from '../assets/imgs/new/avatar.png';
import { Link, useHistory } from 'react-router-dom';
import { Button, Col, CustomInput, Form, Input, Label, Row } from 'reactstrap';
import Media from '../assets/imgs/new/Media.png';
import qrCode1 from '../assets/imgs/new/qr-code1.png';
import qrCode2 from '../assets/imgs/new/qr-code2.png';
import qrCode3 from '../assets/imgs/new/qr-code3.png';
import { useSelector, useDispatch } from 'react-redux';
import { getMemoirs } from '../redux/actions/memoir.action';
import MemoirCard from '../components/MemoirCard';
import QRCode from 'qrcode.react';
import { useLocation } from 'react-router-dom';
import MainHeader from '../components/MainHeader';
import { toast } from 'react-toastify';
import { customAlert } from '../redux/actions/alertActions';

function QrCode() {
	// States
	const [active, setActive] = useState(-1);
	const [activeQRCode, setActiveQRCode] = useState(-1);
	const [activeQRColor, setActiveQRColor] = useState(-1);
	const [generate, setGenerate] = useState(false);
	const [qrValue, setQRValue] = useState('');
	const [qrID, setQRID] = useState('');
	const [memoirId, setMemoirID] = useState('');
	const [qrTopText, setQRTopText] = useState('');
	const [qrBottomText, setQRBottomText] = useState('');
	const [selectedQr, setSelectedQr] = useState('');

	const location = useLocation();

	const qrCodes = [qrCode1, qrCode2, qrCode3];
	const qrCodesBGColors = ['#DBC3A6', '#FBBB00', '#FF4B55'];

	const history = useHistory();

	// React-Redux

	const { id } = useSelector(state => state.authUser);
	const { memoirs } = useSelector(state => state.memoir);
	const dispatch = useDispatch();

	const setActiveMedia = idx => {
		setActive(idx);
	};
	const setActiveQR = idx => {
		setActiveQRCode(idx);
	};
	const setActiveQRColorCode = val => {
		setActiveQRColor(val);
	};
	const getRandomNumber = () => {
		return Math.floor(Math.random() * (1000000, 10000000) + 1000000);
	};
	useEffect(() => {
		if (memoirs.length == 0) {
			dispatch(getMemoirs(id));
		}
	}, []);
	const getMemoirData = id => {
		if (memoirs && memoirs.length > 0) {
			let obj = memoirs.find(mem => mem.id == id);
			if (obj) {
				return obj;
			} else {
				return {};
			}
		} else {
			return {};
		}
	};
	const getRole = (memId, uid) => {
		let memoirData = memoirs.find(mem => mem.id == memId);
		let roleCheck = memoirData.collaborators.find(
			collab => collab.id == uid
		);
		if (roleCheck) {
			return roleCheck.role;
		} else {
			return 'owner';
		}
	};
	useEffect(() => {
		if (location.state && location.state.selectedMemoir) {
			setSelectedQr(location.state.selectedMemoir);
			setMemoirID(location.state.selectedMemoir);
		}
	}, [location.state]);
	return (
		<>
			<div className='container-fluid pt-3'>
				<MainHeader heading={'Creation of qr code'} />
				<hr className='mb-0' />
				<Form>
					<Row noGutters>
						<Col lg='12' xl={`${generate ? '8' : '12'}`}>
							<h4 className='mt-5 text-lightpurple font-weight-bold'>
								Step 1
							</h4>
							{selectedQr != '' ? (
								<>
									<Row
										noGutters
										className='mt-5 flex-nowrap'
										style={{ overflow: 'auto' }}
									>
										<Col xl='5' lg='6' md='6'>
											{Object.keys(
												getMemoirData(selectedQr)
											).length > 0 && (
												<LC_Media
													memoir={getMemoirData(
														selectedQr
													)}
													active={true}
													setMemoirID={setMemoirID}
													setActiveMedia={e =>
														setActiveMedia(true)
													}
												/>
											)}
										</Col>
									</Row>
								</>
							) : (
								<>
									<p className='font-weight-semibold'>
										Select timeline page
									</p>
									{/* <Row className="mt-4">
                            <Col md="3">
                                <Label>Selected Date</Label>
                                <Input type="date"></Input>
                            </Col>
                            <Col md="4">
                                <Label>Selected Milestone</Label>
                                <Input type="select"></Input>
                            </Col>
                        </Row> */}
									<Row
										noGutters
										className='mt-5 flex-nowrap'
										style={{ overflow: 'auto' }}
									>
										{memoirs &&
											memoirs.map((memoir, idx) => (
												<Col xl='5' lg='6' md='6'>
													<LC_Media
														memoir={memoir}
														active={active == idx}
														setMemoirID={
															setMemoirID
														}
														setActiveMedia={e =>
															setActiveMedia(idx)
														}
													/>
												</Col>
											))}
									</Row>
								</>
							)}

							<h4 className='mt-3 font-weight-semibold text-lightpurple'>
								Step 2
							</h4>
							<p className='font-weight-semibold'>
								Choose from templates
							</p>
							<Row>
								{new Array(3).fill(1).map((_, idx) => (
									<Col md='6' lg='4' xl='3'>
										<QRCodeTemplate
											qrCode={qrCodes[idx]}
											bgColor={qrCodesBGColors[idx]}
											setQRValue={setQRValue}
											setActiveQRColor={e => {
												setActiveQRColorCode(
													qrCodesBGColors[idx]
												);
											}}
											idx={idx + 1}
											active={activeQRCode == idx}
											setActiveQR={e => setActiveQR(idx)}
										/>
									</Col>
								))}
							</Row>
							<div className='row mt-5'>
								<div className='col-lg-8'>
									<h4 className='mt-3 font-weight-semibold text-lightpurple'>
										Step 3
									</h4>
									<p className='font-weight-semibold'>
										Customize your text
									</p>

									<div className='row my-4'>
										<div className='col-md-8'>
											<div className='form-group'>
												<label>Top text</label>
												<input
													required
													className='form-control'
													placeholder='Enter text'
													value={qrTopText}
													onChange={e =>
														setQRTopText(
															e.target.value
														)
													}
												></input>
											</div>
											<div className='form-group'>
												<label>Bottom text</label>
												<input
													required
													className='form-control'
													placeholder='Enter text'
													value={qrBottomText}
													onChange={e =>
														setQRBottomText(
															e.target.value
														)
													}
												></input>
											</div>
										</div>
									</div>
									<span className='d-block mt-2'>
										<button
											disabled={
												activeQRCode < 0 ||
												!memoirId ||
												!qrTopText ||
												!qrBottomText
											}
											className='btn btn-outline dashboard-btn'
											onClick={e => {
												e.preventDefault();
												if (
													getRole(memoirId, id) ==
													'contributer'
												) {
													dispatch(
														customAlert(
															true,
															'You are a contributor in this selected memoir!'
														)
													);
													setTimeout(() => {
														dispatch(
															customAlert(
																false,
																''
															)
														);
													}, 1500);
													// toast.warning(
													//   'You are a contributor in this selected memoir!'
													// );
												} else {
													setGenerate(true);
												}
											}}
										>
											Generate QR Code
										</button>
									</span>
								</div>
							</div>
						</Col>
						<Col
							lg='12'
							xl='4'
							style={{ borderLeft: '1px solid #000000' }}
							className={`${generate ? 'd-block' : 'd-none'}`}
						>
							<div className='d-flex p-4'>
								<div className='d-flex'>
									<i
										className='fa fa-times pointer'
										onClick={e => setGenerate(false)}
									></i>
								</div>
								<span className='mx-auto'>
									<h5 className='mt-3 font-weight-semibold text-lightpurple mb-4'>
										Preview
									</h5>
									<div className='preview mx-auto'>
										<div className='top-text'>
											{qrTopText}
										</div>
										<div
											className='p-4 m-0 text-center'
											style={{
												backgroundColor:
													qrCodesBGColors[
														activeQRCode
													],
											}}
										>
											<QRCode
												value={qrValue}
												bgColor={
													qrCodesBGColors[
														activeQRCode
													]
												}
												fgColor='#484E9C'
											/>
											{/* <img
                                                src={qrCode1}
                                                style={{
                                                    width: "100%",
                                                    height: "100%",
                                                    objectFit: "cover",
                                                }}
                                            /> */}
										</div>
										<div className='bottom-text'>
											{qrBottomText}
										</div>
									</div>
									<button
										className='btn btn-outline mt-5 dashboard-btn'
										style={{ height: 'auto' }}
										onClick={e => {
											let obj = {
												memoir: memoirId,
												qrValue: qrValue,
												template: activeQRCode,
												color: activeQRColor,
												topText: qrTopText,
												bottomText: qrBottomText,
												qrID:
													'MEM' +
													getRandomNumber() +
													'QR',
											};
											localStorage.setItem(
												'QR_Data',
												JSON.stringify(obj)
											);
											history.push(
												'/dashboard/qrcode/order'
											);
										}}
									>
										Order Metal QR Code
									</button>
									{/* <Link
                                        to="/dashboard/qrcode/order"

                                    >
                                    </Link> */}
								</span>
							</div>
						</Col>
					</Row>
				</Form>
			</div>
		</>
	);
}

const LC_Media = props => {
	let { active, setActiveMedia, memoir, setMemoirID } = props;
	return (
		<div
			className={`lc_media pointer p-4 ${active ? 'active' : ''}`}
			onClick={() => {
				setActiveMedia();
				setMemoirID(memoir.id);
			}}
		>
			<div className='w-100 position-relative'>
				<MemoirCard
					mem={memoir}
					showMenu={false}
					toggleDropDown={() => {}}
					height='130px'
					linkable={false}
					settings={false}
				/>
				<div
					className={`position-absolute ${
						active ? 'd-block' : 'd-none'
					}`}
					style={{ top: 10, left: 10 }}
				>
					<CustomInput
						type='checkbox'
						id='exampleCustomCheckbox'
						checked={true}
						label=''
					/>
				</div>
			</div>
		</div>
	);
};

const QRCodeTemplate = props => {
	let {
		qrCode,
		idx,
		active,
		setActiveQR,
		bgColor,
		setQRValue,
		setActiveQRColor,
	} = props;
	return (
		<div
			onClick={e => {
				e.preventDefault();
				setActiveQR();
				setActiveQRColor(bgColor);
				setQRValue('https://memora-new.firebaseapp.com/main');
			}}
		>
			<div
				className='pointer qr-code-wrapper p-4 text-center'
				style={{ backgroundColor: bgColor, borderRadius: 8 }}
			>
				<QRCode
					value='https://memora-new.firebaseapp.com/main'
					bgColor={bgColor}
					fgColor='#484E9C'
				/>
				{/* <img
                    src={qrCode}
                    style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                    }}
                /> */}
			</div>
			<div className='mt-3'>
				<CustomInput
					type='radio'
					id={`Template ${idx}`}
					name='customRadio'
					checked={active}
					label={`Template ${idx}`}
				/>
			</div>
		</div>
	);
};

export default QrCode;
